import Dark from './Dark'
import Light from './Ligth'

export const GuigoLight = Light
export const GuigoDark = Dark
